
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/author/[slug]",
      function () {
        return require("private-next-pages/author/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/author/[slug]"])
      });
    }
  